module.exports = __webpack_public_path__ + "static/img/hotel-karosta-2.5f0788c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/1911262/hotel-karosta-2.jpeg
// module id = LekR
// module chunks = 1